import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';

import { history } from '_helpers';
import { Nav, Alert, PrivateRoute } from '_components';
import { GeolocalisationLayout } from 'views/geolocalisation';
import { AccountLayout } from 'views/account';
import { UserLayout, UsersLayout } from 'views/users';
import { DataLayout, AlertsLayout, FiltersLayout } from 'views/portal';
import { useSelector } from 'react-redux';
import { Home } from 'views/home';
import { ResetPassword } from 'views/account/ResetPassword';
import { useEffect, useState } from 'react';
import Spinner from '_components/Spinner';
import { DiagnosticLoggerLayout } from 'views/portal/diagnosticLogger';


export { App };

function App() {
    // init custom history object to allow navigation from 
    // anywhere in the react app (inside or outside components)
    history.navigate = useNavigate();
    history.location = useLocation();

    const auth = useSelector(x => x?.auth?.value);

    /* Gestion du spinner sur toute l'application */
    const [isLoading, setIsloading] = useState(false);
    const filterIsLoading = useSelector(state => state.filters.isLoading);
    const mapIsLoading = useSelector(state => state.map.isLoading);
    const eventsIsLoading = useSelector(state => state.events.isLoading);
    const vehicleIsLoading = useSelector(state => state.vehicles.isLoading);
    const vehicleDettailsIsLoading = useSelector(state => state.vehicles.selectedVehicleDetails.isLoading);
    const contextDetailsIsLoading = useSelector(state => state.contextDetails.isLoading);
    const usersIsLoading = useSelector(state => state.users.isLoading);
    const preAlertIsLoading = useSelector(state => state.preAlerts.isLoading);
    const mailIsLoading = useSelector(state => state.emails.isLoading);
    const dataCollectorIsLoading = useSelector(state => state.dataCollector.isLoading);
    const diagnosticLoggerIsLoading = useSelector(state => state.diagnosticLogger.isLoading);


    useEffect(() => {
        if(mapIsLoading || filterIsLoading || eventsIsLoading || vehicleIsLoading || vehicleDettailsIsLoading || contextDetailsIsLoading || usersIsLoading || preAlertIsLoading || mailIsLoading || dataCollectorIsLoading || diagnosticLoggerIsLoading){
            setIsloading(true);
        } else {
            setIsloading(false)
        }
    }, [mapIsLoading, filterIsLoading, eventsIsLoading, vehicleIsLoading, vehicleDettailsIsLoading, contextDetailsIsLoading, usersIsLoading, preAlertIsLoading, mailIsLoading, dataCollectorIsLoading, diagnosticLoggerIsLoading])

    return (
        <>
            {isLoading && <Spinner />}
            <Nav />
            <Alert />        
            <Routes>
                {/* private */}
                <Route element={<PrivateRoute />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/geolocalisation" element={<GeolocalisationLayout />} />
                    {auth?.role !== 'user_geolocalisation' &&  
                    <>
                        <Route path="/donnees/*" element={<DataLayout />} />
                        <Route path="/alertes/*" element={<AlertsLayout />} />
                        <Route path="/filtres/*" element={<FiltersLayout />} />
                        <Route path="/diagnostic/*" element={<DiagnosticLoggerLayout />} />
                    </>}
                    {auth?.role === 'admin' && <Route path="utilisateurs/*" element={<UsersLayout />} />}
                    <Route path="/utilisateur/:username/*" element={<UserLayout />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
                {/* public */}
                <Route path="account/*" element={<AccountLayout />} />
                <Route path="reset_password" element={<ResetPassword />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>            
        </>
    );
}
